import React from 'react'

import {Box, Typography, Theme} from '@mui/material'
import {makeStyles} from 'tss-react/mui'

export interface NavigationItem {
  itemID: string
  label: string
}

export interface NavigationProps {
  items: NavigationItem[]
  activeItemID: string
  onItemClick?: (itemID: string) => void
  colors?: any // Product line colors
}

const useStyles = makeStyles<{colors?: any}>()((theme: Theme, {colors}) => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
  },
  item: {
    padding: '8px 32px',
    borderRadius: '100px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    '&:hover': {
      opacity: 0.8,
    },
  },
  inactiveItem: {
    fontFamily: 'DM Sans',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '24px',
    color: '#9CA3AF',
    background: 'transparent',
  },
  activeItem: {
    fontFamily: 'DM Sans',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '24px',
    color: '#fff',
    background: colors?.primary || '#148199',
  },
}))

const Navigation: React.FC<NavigationProps> = ({
  items,
  activeItemID,
  onItemClick,
  colors,
}) => {
  const {classes} = useStyles({colors})

  const handleItemClick = (itemID: string) => {
    if (onItemClick) {
      onItemClick(itemID)
    }
  }

  return (
    <Box className={classes.container}>
      {items.map((item) => {
        const isActive = item.itemID === activeItemID
        const itemClass = isActive ? classes.activeItem : classes.inactiveItem

        return (
          <Box
            key={item.itemID}
            className={`${classes.item} ${itemClass}`}
            onClick={() => handleItemClick(item.itemID)}
            data-testid={`consultations-nav-${item.itemID}`}
          >
            <Typography
              sx={{
                fontFamily: 'DM Sans',
                fontStyle: 'normal',
                fontWeight: 400,
                fontSize: '16px',
                lineHeight: '24px',
                color: 'inherit',
              }}
            >
              {item.label}
            </Typography>
          </Box>
        )
      })}
    </Box>
  )
}

export default Navigation
